// @import dependencies
import React, { CSSProperties } from 'react'
// @end dependencies

// @import components
import StarsCommon from 'app_components/commons/stars';
// @end components

// @import types
// @end types

// @import services
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './RatingCard.scss'
// @end styles

interface IRatingCardProps {
  title: string
  description: string
  stars: number
  avatar: string
  className?: string
  style?: CSSProperties

}

const RatingCard: React.FC<IRatingCardProps> = (props) => {
  return(
    <div
      className={`rating_card-layout ${props.className ? props.className : ''}`}
      style={props.style}
    >
      <div className="rating-image" style={{backgroundImage: `url(${props.avatar})`}}></div>
      {/* <img src={props.avatar} alt="" /> */}
      <div className="container-info-rating">
        <p>{props.title}</p>
        <StarsCommon starts={props.stars}/>
        <p>{props.description}</p>
      </div>
    </div>
  );
}

export default RatingCard;
